
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Acucar from "../pages/acucar/page";
import Cafe from "../pages/cafe/page";
import Logistica from "../pages/logistica/page";
import Noticias from "../pages/noticias/page";
import Contato from "../pages/contato/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/acucar",
    element: <Acucar />,
  },
  {
    path: "/cafe",
    element: <Cafe />,
  },
  {
    path: "/logistica",
    element: <Logistica />,
  },
  {
    path: "/noticias",
    element: <Noticias />,
  },
  {
    path: "/contato",
    element: <Contato />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
